/**
 * The HKCM logo mark: two panels, hyperblau and navy (white on a dark
 * background, as hkcm.com's favicon does in dark mode). Decorative — the
 * text beside it carries the name.
 */

import { cn } from '../ui/styles'

export default function HkcmMark({ className, onDark = false }: { className?: string; onDark?: boolean }) {
    return (
        <svg viewBox="0 0 112 122" className={cn('shrink-0', className)} aria-hidden="true" focusable="false">
            <g transform="matrix(0.883446,0,0,0.883446,6.32221,6.53212)">
                <path
                    className="fill-hyperblau"
                    d="M29.891,90.548L29.891,50.485C29.891,48.573 31.055,46.349 32.489,45.521L53.549,33.362L2.196,3.713C1.24,3.161 0.464,3.747 0.464,5.022L0.464,71.249C0.464,72.524 1.24,74.007 2.196,74.559L29.891,90.548Z"
                />
            </g>
            <g transform="matrix(0.765086,-0.441723,3.25546e-08,0.883446,34.9735,48.7215)">
                <path
                    className={onDark ? 'fill-white' : 'fill-navy dark:fill-white'}
                    d="M91.878,3.421C91.878,1.257 90.356,-0.5 88.482,-0.5L2.53,-0.5C0.656,-0.5 -0.866,1.257 -0.866,3.421L-0.866,69.882C-0.866,72.046 0.656,73.803 2.53,73.803L88.482,73.803C90.356,73.803 91.878,72.046 91.878,69.882L91.878,3.421Z"
                />
            </g>
        </svg>
    )
}
